module.exports = __webpack_public_path__ + "img/loader.e351f524.svg";